// Collapsed-state placeholder for PredictionAnalysisPanel/MonitoringAnalysisPanel — shown
// instead of the chat panel until the professional opts in, since the chat panel loads
// conversation history + ML/SHAP data eagerly on open.
import Card from "../../Card"
import SmallHeadingComponent from "../../SmallHeadingComponent"

type Props = {
    title: string
    description: string
    onOpen: () => void
}

export default function AnalyseTriggerCard({ title, description, onOpen }: Props) {
    return (
        <Card width="100%">
            <div className="flex flex-col space-y-2">
                <SmallHeadingComponent>{title}</SmallHeadingComponent>
                <p className="text-gray-700 text-sm">{description}</p>
                <button
                    type="button"
                    onClick={onOpen}
                    className="w-fit bg-teal-500 hover:bg-teal-600 text-white px-6 py-2 rounded-lg font-medium text-sm transition-colors"
                >
                    Öffnen →
                </button>
            </div>
        </Card>
    )
}
